import {
  Action,
  createReducer,
  on,
} from '@ngrx/store';
import * as coreActions from '../actions/core.actions';

export interface CoreState {
  somethingWentWrongModalOpen: boolean;
  examReference: string | null;
  installAppWhatNextModalOpen: boolean;
  appNotDetectedModalOpen: boolean;
  goBackToLMSModalOpen: boolean;
  invalidExamTokenModalOpen: boolean;
  unsupportedOperatingSystemModalOpen: boolean;
  chooseYourInstallerModalOpen: boolean;
}

const initialState: CoreState = {
  somethingWentWrongModalOpen: false,
  examReference: null,
  installAppWhatNextModalOpen: false,
  appNotDetectedModalOpen: false,
  goBackToLMSModalOpen: false,
  invalidExamTokenModalOpen: false,
  unsupportedOperatingSystemModalOpen: false,
  chooseYourInstallerModalOpen: false,
};

const reducer = createReducer(
  initialState,
  on(
    coreActions.saveToken,
    (state, { token }) => ({
      ...state,
      examReference: token,
    }),
  ),
  on(
    coreActions.setSomethingWentWrongModalAppComponent,
    (state, { isOpen }) => ({
      ...state,
      somethingWentWrongModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setInstallAppWhatNextModal,
    (state, { isOpen }) => ({
      ...state,
      installAppWhatNextModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setAppNotDetectedModal,
    (state, { isOpen }) => ({
      ...state,
      appNotDetectedModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setGoBackToLMSModal,
    (state, { isOpen }) => ({
      ...state,
      goBackToLMSModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setInvalidExamTokenModal,
    (state, { isOpen }) => ({
      ...state,
      invalidExamTokenModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setUnsupportedOperatingSystemModal,
    (state, { isOpen }) => ({
      ...state,
      unsupportedOperatingSystemModalOpen: isOpen,
    }),
  ),
  on(
    coreActions.setChooseYourInstallerModal,
    (state, { isOpen }) => ({
      ...state,
      chooseYourInstallerModalOpen: isOpen,
    }),
  ),
);

export function coreReducer(state: CoreState | undefined, action: Action): CoreState {
  return reducer(state, action);
}
